/**
 * DashboardContext - ダッシュボードの選択状態のみを管理
 * API通信、URL同期、Cookie管理は別の層で実施
 */
import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const DashboardContext = createContext();

/**
 * DashboardContextを使用するためのフック
 */
export function useDashboard() {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error('useDashboard must be used within DashboardProvider');
  }
  return context;
}

/**
 * DashboardProvider - 選択状態のみを管理（シンプル版）
 */
export function DashboardProvider({
  children,
  initialLocation = '',
  initialAction = '',
  initialYear,
  initialMonth,
}) {
  const today = new Date();

  // 選択状態（シンプルなstate管理のみ）
  const [location, setLocation] = useState(initialLocation);
  const [action, setAction] = useState(initialAction);
  const [year, setYear] = useState(
    initialYear != null ? String(initialYear) : String(today.getFullYear())
  );
  const [month, setMonth] = useState(
    initialMonth != null ? String(initialMonth) : String(today.getMonth() + 1)
  );

  useEffect(() => {
    setLocation(initialLocation);
    setAction(initialAction);
    if (initialYear != null) setYear(String(initialYear));
    if (initialMonth != null) setMonth(String(initialMonth));
  }, [initialLocation, initialAction, initialYear, initialMonth]);
  
  const value = {
    // 選択状態
    location,
    setLocation,
    action,
    setAction,
    year,
    setYear,
    month,
    setMonth,
  };
  
  return (
    <DashboardContext.Provider value={value}>
      {children}
    </DashboardContext.Provider>
  );
}

DashboardProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialLocation: PropTypes.string,
  initialAction: PropTypes.string,
  initialYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  initialMonth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
